import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import { NavLinkProps } from '../nav-links/nav-link'
import NavLinks from '../nav-links'
import GetStartedButton from '../get-started-login-button/get-started'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: rgb(18, 18, 18);
    opacity: 0.95;
    overflow: hidden;
    align-items: center;
    justify-content: center;
`

const Menu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 60vh;
`

const Home = styled.span`
    color: white;
    font-weight: bold;
    font-size: 25px;
`

const ExtendedLink = styled(Link)`
    border-bottom: none;
    color: white;
`

type ModalMenuProps = {
    titles: NavLinkProps[]
    isLogin: boolean
}

const ModalMenu = ({ titles, isLogin }: ModalMenuProps) => (
    <Container>
        <Menu>
            <Home>Home</Home>
            <NavLinks titles={titles} />
            <ExtendedLink to={isLogin ? '/dashboard/?create=true' : '/docs/sdk'}>
                <GetStartedButton isLogin={isLogin} />
            </ExtendedLink>
        </Menu>
    </Container>
)

export default ModalMenu
